module.exports = __webpack_public_path__ + "static/media/xkcd_commit.451016cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/git-more-done/assets/xkcd_commit.png
// module id = 389
// module chunks = 0